import { css } from 'linaria';
export const itemActionStyle = "i18uycg6";
export const menuItemStyle = "m11fpiro";

require("./base.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./base.js");